module.exports = __webpack_public_path__ + "media/images/common/jpx-logo-8a201b7799b93a40acbc96d431ed309b.png";